<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="col-12">
      <p class="text-center error">Error: 404.</p>
      <p class="text-center error">No se ha encontrado la página.</p>
    </div>
  </div>
</div>
